import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20open%20manga%20books%20with%20colorful%20pages%20scattered%20under%20a%20blooming%20sakura%20tree%2C%20falling%20petals%2C%20soft%20golden%20afternoon%20sunlight%2C%20cozy%20reading%20atmosphere%2C%20warm%20coral%20pink%20and%20amber%20palette%2C%20gentle%20cinematic%20light%2C%20stylized%20anime%20artwork%2C%20rich%20texture&width=1600&height=700&seq=cta-sakura&orientation=landscape"
        alt="樱花树下的漫画书"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-start px-4 py-16 md:px-6 md:py-24">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500/90 px-4 py-1.5 text-xs font-medium text-background-50">
          <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
          即刻开始追漫
        </span>
        <h2 className="mt-5 max-w-xl font-heading text-3xl font-black leading-snug text-background-50 md:text-5xl md:leading-snug">
          你的下一部心头好，
          <br />
          也许就在这里
        </h2>
        <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-100/90 md:text-base">
          浏览热门排行、按题材探索漫画库，或订阅每周漫讯，让好作品主动来到你身边。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/manga"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始探索
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/60 bg-white/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-white/20"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}